<template>
  <div class="details-component">
    <div class="details-component__header">

      <h1>{{ $t('common.products') }}</h1>

    </div>

    <div class="details-component__content content" v-if="products.items">
      <v-client-table class="mobile-1050" :data="products.items" :columns="columns" :options="options"></v-client-table>
    </div>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import * as mTypes from 'store/mutation-types';

  export default {
    computed: mapGetters({
      products: 'zones/products/products',
      user: 'user/user/user',
    }),
    created() {
      this.fetchZoneProducts();
    },
    watch: {
      $route: 'fetchZoneProducts',
    },
    methods: {
      routeToProduct(product) {
        this.$router.push({ name: 'product', params: { id: product.id } });
      },
      fetchZoneProducts() {
        if (this.$route.params.id && this.user.data) {
          this.$store.dispatch('zones/products/fetch', { id: this.$route.params.id, user: this.user }).then(() => {
          });
        } else {
          this.$store.commit(`zones/products/${mTypes.CLEAR_STATE}`);
        }
      },
    },
    data() {
      return {
        columns: ['type', 'name', 'address', 'total', 'issued'],
        options: {
          texts: {
            noResults: this.$t('tenants.no_matching_records'),
            count: this.$t('tables.count'),
          },
          perPage: 10,
          filterable: false,
          rowClassCallback: () => 'VueTables__row',
          headings: {
            type: () => this.$t('products.type'),
            name: () => this.$t('common.name'),
            address: () => this.$t('common.address'),
            issued: () => this.$t('common.issued'),
            total: () => this.$t('products.parking_spots'),
          },
          templates: {
            type: (h, row) => (
              <span class="mobile-padding">
                <span class="mobile">{ this.$t('products.type') }: </span>
                <span class="total">{ this.$t(`product.${row.type}`) }</span>
              </span>
            ),
            address: (h, row) => (
              <span class="mobile-padding">
                <span class="mobile">{ this.$t('common.address') }: </span>
                <span class="total">{ row.address }</span>
              </span>
            ),
            issued: (h, row) => (
              <span class="mobile-padding">
                <span class="mobile">{ this.$t('common.issued') }: </span>
                <span v-show={row.type === 'permitPack'}>{row.issued}</span>
              </span>
            ),
            total: (h, row) => (
              <span class="mobile-padding">
                <span class="mobile">{ this.$t('products.parking_spots') }: </span>
                <span v-show={row.type === 'permitPack'}>{row.total}</span>
              </span>
            ),
            name: (h, row) => (
              <span class="mobile-padding">
                <span class="mobile">{ this.$t('common.name') }: </span>
                <a class="link" on-click={ () => this.routeToProduct(row) }>
                  <span>{row.name}</span>
                </a>
              </span>
            ),
          },
        },
      };
    },
  };
</script>
<style lang="scss" scoped>
  @import '~styles/blocks/details.scss';
  .details-component__listWidget {
    width: 50%;
  }

  .link {
    .icon--plus {
      position: relative;
      top: -1px;
      margin: 0 5px;
      font-weight: 900;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/zones/ProductsTable.vue